import Passport from '@mos-front-components/public/es/components/Passport';

const { FIELD_NAME } = Passport;

const passportEditableFields = passport => {
  const editableFields = [];
  const { byWhom, dateOfIssue, number } = passport;

  if (!byWhom) {
    editableFields.push(FIELD_NAME.byWhom);
  }

  if (!dateOfIssue) {
    editableFields.push(FIELD_NAME.dateOfIssue);
  }

  if (!number) {
    editableFields.push(FIELD_NAME.number);
  }

  return editableFields;
};

export default passportEditableFields;
